module.exports = __webpack_public_path__ + "img/animation.df2a7ee3.gif";